import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Stop24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21C9.61305 21 7.32387 20.0518 5.63604 18.364C3.94821 16.6761 3 14.3869 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604ZM12 4.46939C10.0028 4.46939 8.08732 5.26279 6.67505 6.67505C5.26279 8.08732 4.46939 10.0028 4.46939 12C4.46939 13.9972 5.26279 15.9127 6.67505 17.3249C8.08732 18.7372 10.0028 19.5306 12 19.5306C13.9972 19.5306 15.9127 18.7372 17.3249 17.3249C18.7372 15.9127 19.5306 13.9972 19.5306 12C19.5306 10.0028 18.7372 8.08732 17.3249 6.67505C15.9127 5.26279 13.9972 4.46939 12 4.46939ZM8.5102 9.2449C8.5102 8.83914 8.83914 8.5102 9.2449 8.5102H14.7551C15.1609 8.5102 15.4898 8.83914 15.4898 9.2449V14.7551C15.4898 15.1609 15.1609 15.4898 14.7551 15.4898H9.2449C8.83914 15.4898 8.5102 15.1609 8.5102 14.7551V9.2449ZM9.97959 9.97959V14.0204H14.0204V9.97959H9.97959Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
